export class GeoJsonPoint {
    constructor() {
        this.type = "Point";
        this.properties = {};
    }

    type: "Point";
    properties: { [key: string]: any };
    geometry?: Geometry;
}

export class Geometry {
    constructor(){
        this.type = "Point";
        this.coordinates = [];
    }

    type: "Point" | "Polygon";
    coordinates: number[] | number[][][]
}